var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upgradeBar --global-clickable",on:{"click":function($event){return _vm.upgrade()}}},[_c('span',{staticClass:"upgradeBarLabel"},[_vm._v(_vm._s(_vm.$t(_vm.text)))])])}
var staticRenderFns = []

export { render, staticRenderFns }